const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const NotifyApi = require('notify/infra/api/notify');
const Backbone = require('backbone');

const AlreadyFetched = {
    unread: {},
    all: {}
};

const getResourceByIds = function(ids) {
    const project_ids = _.filter(ids, function(id){
        return id.split(':')[0] == 'project';
    });
    if(project_ids.length > 0) {
        return project_ids[0];
    }
    const group_ids = _.filter(ids, function(id){
        return id.split(':')[0] == 'group';
    });
    if(group_ids.length > 0) {
        return group_ids[0];
    }
};

const ReviewActionCreater = Backbone.Model.extend({
    fetchReviews: function(params) {
        const resource = params.resourceIds ? getResourceByIds(params.resourceIds) : null;
        const read = params.all ? 'all' : 'false';
        const limit = params.limit ? params.limit : 10;
        const urlParams = {
            type: 'review',
            limit: limit,
            read: read,
            resource: resource,
            latest: params.latest,
            oldest: params.oldest
        };
        const fetchMore = params.oldest;
        return new Promise((resolve, reject) => {
            NotifyApi.getMyNotifications(urlParams)
                .then(reviews => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_REVIEW,
                        review: reviews["results"],
                        options: {fetched: true, fetchMore: fetchMore}
                    });
                    resolve();
                }, reject);
        });
    },

    fetchReviewsOnce: function(params) {
        const resource = params.resourceIds ? getResourceByIds(params.resourceIds) : null;
        const read = params.all ? 'all' : 'unread';
        const latest = params.latest ? params.latest : null;
        const oldest = params.oldest ? params.oldest : null;
        const key = latest + ":" + oldest;
        let deferred = AlreadyFetched[read][resource] && AlreadyFetched[read][resource][key];
        if(!deferred) {
            deferred = this.fetchReviews(params);
            if (!AlreadyFetched[read][resource]) {
                AlreadyFetched[read][resource] = {};
            }
            AlreadyFetched[read][resource][key] = deferred;
        }
        return deferred;
    },

    createReview: function(reviews) {
        Dispatcher.dispatch({
            type: Actions.CREATE_REVIEW,
            review: reviews
        });
    },

    read: function(params) {
        let reviews = params.review;
        if(!_.isArray(reviews)) {
            reviews = [reviews];
        }
        const ids = _.map(reviews, function(n){return n.id;});
        return new Promise((resolve, reject) => {
            NotifyApi.postRead(ids)
                .then(ids => {
                    Dispatcher.dispatch({
                        type: Actions.READ_REVIEW,
                        review: _.map(ids, function(id) {
                            return {id: id};
                        }),
                        read: true
                    });
                    resolve();
                }, reject);
        });
    },

    unread: function(params) {
        let reviews = params.review;
        if(!_.isArray(reviews)) {
            reviews = [reviews];
        }
        const ids = _.map(reviews, function(n){return n.id;});
        return new Promise((resolve, reject) => {
            NotifyApi.postUnread(ids)
                .then(ids => {
                    Dispatcher.dispatch({
                        type: Actions.READ_REVIEW,
                        review: _.map(ids, function(id) {
                            return {id: id};
                        }),
                        read: false
                    });
                    resolve();
                }, reject);
        });
    }
});

module.exports = new ReviewActionCreater();



// WEBPACK FOOTER //
// ./notify/domain/action/review.js